import { html } from "lit";
import { NotificationTypeName } from "../src";
import { SalutationName } from "../src/api/salutation";

export interface CreateServiceCallProps {
    /**
     * Should be displayed as multi-step form
     */
    multipleSteps?: boolean;
    /**
     * Offers a file upload in the form
     */
    fileUpload?: boolean;
    /**
     * Locale for the form
     */
    locale?: string;
    /**
     * Salutation of the user
     */
    salutation?: SalutationName;
    /**
     * First name of the user
     */
    firstName?: string;
    /**
     * Last name of the user
     */
    lastName?: string;
    /**
     * Email of the user
     */
    email?: string;
    /**
     * Phone of the user
     */
    phone?: string;
    /**
     * Notification type name
     */
    notificationTypeName?: NotificationTypeName;
    /**
     * Error numbers
     */
    errorNumbers?: string;
    /**
     * Event when the call is created
     */
    onMfServiceCallSubmit?: () => void;
    /**
     * Event when the call is canceled
     */
    onMfServiceCallCancel?: () => void;
}
/**
 * CreateServiceCall Form Micro Frontend
 */
export const CreateServiceCall = ({
    multipleSteps,
    fileUpload,
    locale,
    salutation,
    firstName,
    lastName,
    email,
    phone,
    notificationTypeName,
    errorNumbers,
    onMfServiceCallSubmit,
    onMfServiceCallCancel
}: CreateServiceCallProps) => {
    return html`
        <mf-create-service-call
            locale="${locale}"
            salutation="${salutation}"
            first-name="${firstName}"
            last-name="${lastName}"
            email="${email}"
            phone="${phone}"
            notification-type-name="${notificationTypeName}"
            error-numbers="${errorNumbers}"
            ?multiple-steps=${multipleSteps}
            ?file-upload=${fileUpload}
            @mfServiceCallSubmit="${onMfServiceCallSubmit}"
            @mfServiceCallCancel="${onMfServiceCallCancel}"
        >
        </mf-create-service-call>
    `;
};
